import type * as React from "react"
import "../../styles/marquee.css"

interface MarqueeProps {
  children: React.ReactNode
  pauseOnHover?: boolean
  direction?: "left" | "right"
  speed?: number
  className?: string
}

export function Marquee({
                          children,
                          pauseOnHover = false,
                          direction = "left",
                          speed = 50,
                          className = "",
                          ...props
                        }: MarqueeProps) {
  return (
      <div className={`overflow-hidden w-full z-10 ${className}`} {...props}>
        <div className="relative flex overflow-hidden py-5">
          <div
              className={`flex min-w-max ${direction === "left" ? "animate-marquee" : "animate-marquee-reverse"} ${
                  pauseOnHover ? "hover:[animation-play-state:paused]" : ""
              }`}
              style={{
                animationDuration: `${speed}s`,
              }}
          >
            {children}
          </div>
          <div
              className={`flex min-w-max ${direction === "left" ? "animate-marquee" : "animate-marquee-reverse"} ${
                  pauseOnHover ? "hover:[animation-play-state:paused]" : ""
              }`}
              style={{
                animationDuration: `${speed}s`,
              }}
          >
            {children}
          </div>
        </div>
      </div>
  )
}
